import DIApi from './_diApi';

class DepartmentAPI extends DIApi {
  controllerName = 'departments';
}

export default new DepartmentAPI();
